import React from "react";
import * as Styles from "./styles/FilterCheckInputStyles";
import * as Type from "../../../../shared-components/deprecated-styled-components/toyota/globals/Type";
import Checkbox from "../../../../shared-components/toyota/styles/molecules/Checkbox";
import { SrOnly } from "../../../../shared-components/toyota/styles/utils/Accessibility.styles";
import { useCarFilterLabel } from "../../../utils/constants/labels";

type FilterCheckInput = {
    checked: boolean;
    label?: string;
    onChange?: () => void;
    disabled?: boolean;
    id: string;
    resultCount?: number;
    checkboxVariant?: boolean;
};

const FilterCheckInput = ({
    checked,
    label,
    onChange,
    disabled,
    id,
    resultCount,
    checkboxVariant,
}: FilterCheckInput): JSX.Element => {
    const resultsLabel = useCarFilterLabel("carFilterAriaResults");
    return (
        <Checkbox
            variant="form"
            id={id}
            title={label}
            disabled={disabled}
            onClick={onChange}
            checked={checked}
            readOnly
        >
            {label}
            {typeof resultCount !== "undefined" &&
                !Number.isNaN(resultCount) &&
                (checkboxVariant ? (
                    <Type.SmallText>
                        {resultCount}
                        <SrOnly>{resultsLabel}</SrOnly>
                    </Type.SmallText>
                ) : (
                    <Styles.InfoText data-testid="checkbox-infotext-result">
                        {resultCount}
                        <SrOnly>{resultsLabel}</SrOnly>
                    </Styles.InfoText>
                ))}
        </Checkbox>
    );
};

export default FilterCheckInput;
